export function openUrlInNewWindow(url: string | URL) {
  const windowName = '_blank'
  const windowFeatures = 'noopener,noreferrer'
  window.open(url, windowName, windowFeatures)
}
